import { engineRequest } from './http';

export const listDefaults = params =>
  engineRequest({ path: '/routing/defaults', params });

export const createDefault = fields =>
  engineRequest({ method: 'post', path: '/routing/defaults', data: fields });

// The category is fixed; an empty `primary_role` is refused (422 role_unknown).
export const updateDefault = (id, fields) =>
  engineRequest({
    method: 'put',
    path: `/routing/defaults/${id}`,
    data: fields,
  });

export const deleteDefault = id =>
  engineRequest({ method: 'delete', path: `/routing/defaults/${id}` });

export const listOverrides = params =>
  engineRequest({ path: '/routing/overrides', params });

// As a default plus a required `site_id`. A null backup, supervisor or tier
// inherits the default's value.
export const createOverride = fields =>
  engineRequest({ method: 'post', path: '/routing/overrides', data: fields });

// Condo and category are fixed: delete and re-create to move.
export const updateOverride = (id, fields) =>
  engineRequest({
    method: 'put',
    path: `/routing/overrides/${id}`,
    data: fields,
  });

export const deleteOverride = id =>
  engineRequest({ method: 'delete', path: `/routing/overrides/${id}` });

// The backend's answer for who would get a ticket. Never recompute it in the
// browser. Query: `category` (required), `site_id`, `date`, `tier`.
export const resolveRouting = params =>
  engineRequest({ path: '/routing/resolve', params });
